import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
    selector: 'ar-logo',
    template: `
		<div [outerHTML]="html"></div>
	`,
})
export class ArLogoComponent implements OnInit {
    constructor(private sanitizer: DomSanitizer) { }

    @Input() size = 35;

    html: SafeHtml = ''

    ngOnInit() {
        this.html = this.getIconHTML()
    }

    getIconHTML(sanitized = true) {
        const html = `
            <svg id="Calque_1" data-name="Calque 1" width="${this.size}" height="${this.size}" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" viewBox="0 0 37 37">
                <defs>
                    <style>
                        .cls-1{
                          fill:url(#Dégradé_sans_nom_10);
                        }
                        .cls-2{
                          fill:#fff;
                        }
                    </style>
                    <radialGradient id="Dégradé_sans_nom_10" cx="172.12" cy="172.12" r="172.12" gradientTransform="translate(0 0) scale(0.11 0.11)" gradientUnits="userSpaceOnUse">
                        <stop offset="0" stop-color="#f37f86"/>
                        <stop offset="1" stop-color="#ed1c24"/>
                    </radialGradient>
                </defs>
                <rect class="cls-1" width="37" height="37" rx="2.13"/>
                <path class="cls-2" d="M161.06,180.21H157.2L162.6,164h4.66l5.4,16.18h-4l-1-3.31h-5.66Zm2-6.87-.16.58h3.89l-.17-.58c-.47-1.56-.85-2.9-1.14-4s-.48-1.81-.54-2.13l-.1-.48A67.64,67.64,0,0,1,163.1,173.34Z" transform="translate(-153.62 -153.62)"/>
                <path class="cls-2" d="M178,180.21h-3.7V164h5.6a6.36,6.36,0,0,1,4.35,1.44,4.74,4.74,0,0,1,1.65,3.74,4.79,4.79,0,0,1-3,4.78l4.11,6.22h-4.42l-3.5-5.62H178ZM179.81,167H178v4.56h1.75a2.1,2.1,0,0,0,2.4-2.35,2.13,2.13,0,0,0-.62-1.62A2.42,2.42,0,0,0,179.81,167Z" transform="translate(-153.62 -153.62)"/>
            </svg>
        `
        return sanitized ? this.sanitizer.bypassSecurityTrustHtml(html) : html
    }

    // LOGO EN VIOLET
    // <svg width="${this.size}" height="${this.size}" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" viewBox="0 0 37 37">
    //     <defs>
    //         <style>
    //             .ar-icon-cls-1 {
    //                 fill: url(#ar-color-gradient);
    //             }
    //
    //             .ar-icon-cls-1, .ar-icon-cls-2 {
    //                 stroke-width: 0px;
    //             }
    //
    //             .ar-icon-cls-3 {
    //                 isolation: isolate;
    //             }
    //
    //             .ar-icon-cls-2 {
    //                 fill: #fff;
    //             }
    //         </style>
    //         <radialGradient id="ar-color-gradient" data-name="Dégradé sans nom" cx="18.5" cy="18.5" r="18.5" gradientTransform="translate(0 37) scale(1 -1)" gradientUnits="userSpaceOnUse">
    //             <stop offset="0" stop-color="#9147FF"></stop>
    //             <stop offset="1" stop-color="#6D09FF"></stop>
    //         </radialGradient>
    //     </defs>
    //     <rect class="ar-icon-cls-1" width="37" height="37" rx="3" ry="3"></rect>
    //     <g class="ar-icon-cls-3">
    //         <g class="ar-icon-cls-3">
    //             <path class="ar-icon-cls-2" d="M 18 10.9 L 13.5 26.2 L 9.9 26.2 L 5.4 10.9 L 8.7 10.9 L 11.7 21.6 L 12.825 17.587 L 10.49 17.587 L 9.953 15.497 L 13.411 15.497 L 14.7 10.9 L 18 10.9 Z" style="" transform="matrix(-1, 0, 0, -1, 23.400001525879, 37.100000474121)"></path>
    //             <path class="ar-icon-cls-2" d="M31.6,26.1h-3.9l-3.4-5.6h-1.5v5.6h-3.2v-15.3h5.3c.7,0,1.4,0,1.9.2.5.1,1,.3,1.5.7.5.3.8.8,1.1,1.3.3.5.4,1.2.4,2s-.2,2-.6,2.8c-.4.7-1,1.3-1.8,1.8l4.1,6.5ZM26.7,15.5c0-.4,0-.7-.2-1s-.3-.5-.7-.6c-.2-.1-.5-.2-.8-.2-.3,0-.6,0-1,0h-1.2v4.1h1c.5,0,.9,0,1.3,0s.6-.2.9-.4c.2-.2.4-.4.5-.7.1-.3.2-.6.2-1Z"></path>
    //         </g>
    //     </g>
    // </svg>
}
